export default "__VITE_ASSET__D8Txp4Ao__"